import { Dto, DtoWithId } from "@mango/core";
import { Relatie } from './relatie';
import { Land } from './land';
import { TypeAdres } from '../enums/type-adres';

@Dto({fullName: "CIJBorculo.Logic.Adres"})
export class Adres extends DtoWithId {
	relatieID: Relatie;
	typeAdres: TypeAdres;
	naam: string;
	contact: string;
	adres1: string;
	adres2: string;
	postcode: string;
	plaats: string;
	landID: Land;
	eMail: string;
	telefoon1: string;
	telefoon2: string;
	fax: string;
	opmerking: string;
}